import { createSelector } from '@ngrx/store';

import { onlineOrderState } from '../root';

export const getCurrentDeliveryProvider = createSelector(onlineOrderState, (onlineOrder) => {
    const deliveryProviderArray = onlineOrder?.orderType?.SupportedDeliveryProviders;

    return deliveryProviderArray?.length > 0 ? deliveryProviderArray[0] : 0;
});
